import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkSuccessOnClick } from '@justgiving/experiments';
import { Button } from '@justgiving/react-tracking';

import { Experiments } from '../../constants/experiments';
import { PageMetaContext } from '../../context';
import {
  MessageOverrides,
  useNotNullableContext,
  usePageOwner,
  useShareUrls,
} from '../../hooks';
import { ShareModal } from '../ShareModal/ShareModal';

import styles from './Share.scss';

interface ShareProps {
  successType: string;
  shareUrl?: string;
  messageOverrides?: MessageOverrides;
}

export const Share: FunctionComponent<ShareProps> = ({
  successType,
  shareUrl,
  messageOverrides,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [isOpen, setOpen] = useState(false);
  const shareUrls = useShareUrls(shareUrl, messageOverrides);
  const { isPageOwner, data: pageOwnerData } = usePageOwner();
  const { pageType } = useNotNullableContext(PageMetaContext);

  const shareModalHeading = isPageOwner
    ? t('shareModal.heading.pageOwner')
    : t('shareModal.heading', {
        pageOwner: pageOwnerData?.owner?.name,
      });

  const keyValues = {
    pageType,
  };

  return (
    <>
      {/*B2C_029 - First to donate*/}
      {/*Can be removed when experiment has ended*/}
      <MarkSuccessOnClick
        testSlug={Experiments.b2c_029_first_to_donate}
        successType={successType}
        keyValues={keyValues}
      >
        <MarkSuccessOnClick
          testSlug={Experiments.b2c_036_donate_button_colour}
          successType={successType}
          keyValues={keyValues}
        >
          <MarkSuccessOnClick
            testSlug={Experiments.b2c_038_secure_donate_buttons}
            successType={successType}
            keyValues={keyValues}
          >
            <MarkSuccessOnClick
              testSlug={Experiments.b2c_040_frp_trust_proposition_bar}
              successType={successType}
            >
              <Button
                className={`jg-btn ${styles.shareButton}`}
                onClick={() => setOpen(true)}
                type="button"
                trackingData={{
                  action_name: 'click',
                  subtype: 'share',
                  event: 'click',
                  event_value: 'share',
                }}
              >
                {t('common.share')}
              </Button>
            </MarkSuccessOnClick>
          </MarkSuccessOnClick>
        </MarkSuccessOnClick>
      </MarkSuccessOnClick>
      {isOpen && shareUrls ? (
        <ShareModal
          heading={shareModalHeading}
          description={t('shareModal.description')}
          onClose={() => setOpen(false)}
          shareItems={shareUrls}
        />
      ) : null}
    </>
  );
};
